import templateStr from 'text!./pa-edit-vehicle.html';
import MetadataDrivenUtil from 'gw-portals-driven-ui-js/MetadataDrivenUtil';
import MetadataDrivenParser from 'gw-portals-driven-ui-js/MetadataDrivenParser';

export default ['MetadataDrivenUIService', (MetadataDrivenUIService) => {
    return {
        restrict: 'A',
        scope: {
            vehicle: '=',
            vehicleImageUrl: '=?',
            readonly: '='
        },
        template: templateStr,

        controller: ['$scope', ($scope) => {
            function resetForm() {
                $scope.vinLoaded = true;
                $scope.isMetadataDrivenUIEnabled = MetadataDrivenUtil.isStepEnabled('pa', 'pa-vehicle-details');

                if ($scope.isMetadataDrivenUIEnabled) {
                    $scope.loading = true;
                    MetadataDrivenUIService.getPresentationMetadata('quoteandbind-pa.{SEGMENT}.vehicleDetails').then(vehicleDetailsPresentationMetadata => {
                        vehicleDetailsPresentationMetadata = new MetadataDrivenParser(vehicleDetailsPresentationMetadata, $scope.vehicle).parsePageContent();
                        $scope.$applyAsync(() => {
                            $scope.presentationData = vehicleDetailsPresentationMetadata;
                            $scope.loading = false;
                        });
                    });
                }
            }

            resetForm();
            $scope.$on('update-form', () => {
                resetForm();
            });
        }]
    };
}];